import {
  Dialog,
  DialogContent,
  Button,
  Box,
  Typography
} from '@mui/material'

const DuplicateImagesModal = ({ open, onClose, duplicateImagesFiles = [] }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="duplicate-images-modal"
      maxWidth="md"
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            minWidth: '400px'
          }
        }
      }}
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogContent sx={{ padding: 0 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 15px 0 20px'
          }}
        >
          <Typography
            sx={{
              color: '#555',
              fontSize: '13px',
              fontWeight: 'bold',
              textAlign: 'left',
              margin: '10px 0 10px 8px',
              lineHeight: '1.6'
            }}
          >
            Document with the name&nbsp;
            {duplicateImagesFiles &&
              duplicateImagesFiles?.map((item, index) => (
                <span key={index}>
                  "
                  {item?.fileName === '' || !item?.fileName
                    ? 'undefined type'
                    : item?.fileName}
                  "
                  {index < duplicateImagesFiles.length - 1 ? ', ' : ''}
                </span>
              ))}{' '}
            already exists.
            <br />
            <br />
            Please try again with the different document.
          </Typography>
        </Box>
      </DialogContent>
      
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '16px 24px'
        }}
      >
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            width: '80px',
            backgroundColor: '#ffc107',
            color: 'white',
            '&:hover': {
              backgroundColor: '#e0a800'
            }
          }}
        >
          Close
        </Button>
      </Box>
    </Dialog>
  )
}

export default DuplicateImagesModal